import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_chevron_left.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-3cb082ca")

_pushScopeId("data-v-3cb082ca")
const _hoisted_1 = { class: "text-xs text-gray-lp-300" }
const _hoisted_2 = { class: "flex flex-row items-center justify-between" }
const _hoisted_3 = { class: "flex flex-row items-center gap-6" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "prev"
}, null, -1)
const _hoisted_5 = { class: "flex flex-row items-center font-semibold text-sm" }
const _hoisted_6 = { class: "flex flex-row items-center gap-6" }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  style: {"transform":"rotate(180deg)"},
  src: _imports_0,
  alt: "next"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", {
  class: "body-day",
  style: {"margin-top":"22px"}
}, [
  /*#__PURE__*/_createVNode("div", null, "Min"),
  /*#__PURE__*/_createVNode("div", null, "Sen"),
  /*#__PURE__*/_createVNode("div", null, "Sel"),
  /*#__PURE__*/_createVNode("div", null, "Rab"),
  /*#__PURE__*/_createVNode("div", null, "Kam"),
  /*#__PURE__*/_createVNode("div", null, "Jum"),
  /*#__PURE__*/_createVNode("div", null, "Sab")
], -1)
const _hoisted_9 = {
  class: "flex flex-row items-center flex-wrap body-date",
  style: {"gap":"11px","margin-top":"18px"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MonthPicker = _resolveComponent("MonthPicker")!
  const _component_LpButton = _resolveComponent("LpButton")!

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.prevDate && _ctx.prevDate(...args)))
        }, [
          _hoisted_4
        ]),
        _createVNode("button", {
          class: "font-semibold",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.prevDate && _ctx.prevDate(...args)))
        }, _toDisplayString(_ctx.months[_ctx.currentMonth - 1]), 1)
      ]),
      _createVNode(_component_MonthPicker, {
        value: new Date(_ctx.dateInit.toISOString()),
        maxMonth: new Date(),
        onInput: _ctx.onSelectMonth
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_5, _toDisplayString(_ctx.months[_ctx.currentMonth]) + " " + _toDisplayString(_ctx.dateInit.getFullYear()), 1)
        ]),
        _: 1
      }, 8, ["value", "maxMonth", "onInput"]),
      _createVNode("div", _hoisted_6, [
        _createVNode("button", {
          class: "font-semibold",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.nextDate && _ctx.nextDate(...args)))
        }, _toDisplayString(_ctx.months[_ctx.currentMonth + 1]), 1),
        _createVNode("button", {
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.nextDate && _ctx.nextDate(...args)))
        }, [
          _hoisted_7
        ])
      ])
    ]),
    _hoisted_8,
    _createVNode("div", _hoisted_9, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.firstDayIndex, (index) => {
        return (_openBlock(), _createBlock("div", {
          key: `firstDaysIndex_${index}`
        }))
      }), 128)),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.lastDay, (index) => {
        return (_openBlock(), _createBlock("div", {
          class: ["text-center", 
          `${_ctx.decideDateStyle(index, _ctx.dateInit, _ctx.lastDay)} ${
            _ctx.type.includes('range-1') ? 'range-1' : ''
          }`
        ],
          key: `lastDays_${index}`,
          onClick: ($event: any) => (
          _ctx.selectDate(index, _ctx.dateInit, _ctx.decideDateStyle(index, _ctx.dateInit, _ctx.lastDay))
        )
        }, _toDisplayString(index), 11, ["onClick"]))
      }), 128)),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.nextDay, (index) => {
        return (_openBlock(), _createBlock("div", {
          key: `nextDay_${index}`
        }))
      }), 128))
    ]),
    _createVNode(_component_LpButton, {
      class: "mt-12",
      title: "Terapkan",
      textColor: "white",
      fontBold: true,
      isWidthFull: true,
      disabled: _ctx.decideDisableSubmitButton,
      onClick: _ctx.onSubmit
    }, null, 8, ["disabled", "onClick"])
  ]))
})